import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Text, Rect } from 'react-konva';
import PropTypes from 'prop-types';
import React from 'react';
import annTools from './commonAnnotationTools';
import Annotation from './annotation';

// must be defined outside of the component to avoid re-rendering loops
const defaultHandleEdit = () => {};
const FreeText = _ref => {
  var _bgColor$;
  let draggable = _ref.draggable,
    scale = _ref.scale,
    pageHeight = _ref.pageHeight,
    offset = _ref.offset,
    dpiScale = _ref.dpiScale,
    selectedID = _ref.selectedID,
    annotation = _ref.annotation,
    onDragEnd = _ref.onDragEnd,
    _ref$handleEdit = _ref.handleEdit,
    handleEdit = _ref$handleEdit === void 0 ? defaultHandleEdit : _ref$handleEdit;
  const _annotation$freeTextA = annotation.freeTextAnnotation,
    fontSize = _annotation$freeTextA.fontSize,
    fontName = _annotation$freeTextA.fontName,
    text = _annotation$freeTextA.text,
    colorString = annotation.colorString,
    textColor = annotation.textColor,
    id = annotation.id;

  // only care about the first one
  const _annTools$adaptPDFRec = annTools.adaptPDFRects(scale, pageHeight, annotation, offset),
    _annTools$adaptPDFRec2 = _slicedToArray(_annTools$adaptPDFRec, 1),
    box = _annTools$adaptPDFRec2[0];

  // Background and text color logic
  let bgColor;
  let textColorRGB;
  let noBg = false;

  // Text color logic
  if (textColor) {
    textColorRGB = annTools.parseColor(textColor);
  } else if (colorString && colorString !== 'undefined undefined undefined undefined') {
    textColorRGB = annTools.parseColor(colorString);
  } else {
    textColorRGB = [0, 0, 0];
  }

  // Background color logic
  if (colorString && colorString !== 'undefined undefined undefined undefined' && textColor) {
    bgColor = annTools.parseColor(colorString);
  } else {
    noBg = true;
  }
  const bgColorRGBAString = bgColor ? "rgba(".concat(bgColor[0], ",").concat(bgColor[1], ",").concat(bgColor[2], ",").concat((_bgColor$ = bgColor[3]) !== null && _bgColor$ !== void 0 ? _bgColor$ : 1, ")") : undefined;
  const textColorRGBAString = "rgba(".concat(textColorRGB[0], ",").concat(textColorRGB[1], ",").concat(textColorRGB[2], ",").concat(textColorRGB[3] || 1, ")");

  // Use the user-set font size and scale it appropriately
  const baseFontSize = fontSize || 14; // Use the user-set font size or default to 14
  const adjustedFontSize = baseFontSize * scale / dpiScale;

  // default to 'Text' if the text value is null or empty
  const textValue = text && text.length ? text : 'Text';
  return /*#__PURE__*/React.createElement(Annotation, {
    scalable: true,
    draggable: draggable,
    box: box,
    selectedID: selectedID,
    annotationID: id,
    dpiScale: dpiScale,
    scale: scale,
    onDragEnd: onDragEnd,
    onDragMove: handleEdit
  }, /*#__PURE__*/React.createElement(Rect, {
    x: box.x / dpiScale,
    y: box.y / dpiScale,
    width: box.w / dpiScale,
    height: box.h / dpiScale,
    fill: noBg ? undefined : bgColorRGBAString
  }), /*#__PURE__*/React.createElement(Text, {
    key: "".concat(id, "-0"),
    x: box.x / dpiScale,
    y: box.y / dpiScale,
    width: box.w / dpiScale,
    height: box.h / dpiScale,
    fontFamily: fontName,
    fontSize: adjustedFontSize,
    lineHeight: 1.15 // to match pdfkit doc's `lineGap` in server/pdfgen and ios' Core Text
    ,
    fill: textColorRGBAString,
    align: "left",
    text: textValue,
    wrap: "word",
    ellipsis: true
  }));
};
FreeText.propTypes = {
  annotation: PropTypes.shape({
    colorString: PropTypes.string,
    textColor: PropTypes.string,
    id: PropTypes.string,
    freeTextAnnotation: PropTypes.shape({
      fontSize: PropTypes.number,
      fontName: PropTypes.string,
      text: PropTypes.string
    })
  }).isRequired,
  dpiScale: PropTypes.number.isRequired,
  draggable: PropTypes.bool.isRequired,
  handleEdit: PropTypes.func,
  offset: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }).isRequired,
  onDragEnd: PropTypes.func.isRequired,
  pageHeight: PropTypes.number.isRequired,
  scale: PropTypes.number.isRequired,
  selectedID: PropTypes.string.isRequired
};
export default FreeText;